import type { ContactInfo } from '@/data/types';
import { Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
import { resolveImagePath } from '@/utils/imageMap';

interface HeaderProps {
  contactInfo: ContactInfo;
  onMobileMenuToggle?: () => void;
  isMobile: boolean;
}

export function Header({ contactInfo, onMobileMenuToggle, isMobile }: HeaderProps) {
  const logoSrc = resolveImagePath('images/WRGLogo2GrnSmall.gif');

  if (isMobile) {
    return (
      <header className="p-4 flex items-center justify-between">
        <button
          onClick={onMobileMenuToggle}
          className="p-2 text-white hover:bg-white/10 rounded-md transition-colors drop-shadow-lg"
          aria-label="Toggle mobile menu"
          style={{ filter: 'drop-shadow(1px 1px 2px rgba(0,0,0,0.8))' }}
        >
          <Menu size={24} />
        </button>
        
        <div className="flex items-center space-x-3">
          <Link to="/" className="flex-shrink-0">
            <img 
              src={logoSrc}
              alt={contactInfo.name + " Logo"}
              width={40}
              height={40}
              className="rounded-md shadow-sm hover:opacity-80 transition-opacity cursor-pointer"
            />
          </Link>
          <div className="text-white font-medium" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }}>
            <div className="text-sm font-semibold">{contactInfo.name.split(' ')[0]}</div>
            <div className="text-sm font-semibold">{contactInfo.name.split(' ').slice(1).join(' ')}</div>
          </div>
        </div>
      </header>
    );
  }

  return (
    <header className="bg-gradient-to-b from-primary-600 to-primary-700 text-center p-6 border-b border-primary-500/20">
      <div className="flex flex-col items-center">
        {/* Logo */}
        <div className="mb-6">
          <Link to="/" className="inline-block">
            <img
              src={logoSrc}
              alt={contactInfo.name + " Logo"}
              width={100}
              height={98}
              className="mx-auto drop-shadow-md hover:opacity-80 transition-opacity cursor-pointer"
            />
          </Link>
        </div>

        {/* Club Information */}
        <div className="text-white">
          <div className="text-sm font-medium opacity-90 mt-4 space-y-1">
            <div>{contactInfo.address}</div>
            <div>{contactInfo.city}, {contactInfo.state} {contactInfo.zipCode}</div>
            <div className="font-semibold">{contactInfo.phone}</div>
          </div>
        </div>
      </div>
    </header>
  );
}